<template>
    <div id="listInvoice">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div v-if="customerId != undefined">
            <data-table-filter-config v-if="isShowFilter" :moduleName="'invoiceSubList'" ref="filterInvoice" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white">
                <custom-pagination
                        :page-changed="onPageChange"
                        :per-page-changed="onPerPageChange" :moduleName="'invoiceList'">
                </custom-pagination>

                <vue-good-table
                            mode="remote"
                            ref="invoiceList"
                            title="Invoices"
                            @on-page-change="onPageChange"
                            @on-sort-change="onSortChange"
                            @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange"
                            @on-selected-rows-change="selectionChanged"
                            :totalRows="totalRecords"
                            :columns="columns"
                            :rows="rows"
                            :isLoading=false
                            :search-options="{
                                    enabled: false,
                                    }"
                            :select-options="{
                                enabled: true,
                                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                selectionInfoClass: 'custom-class',
                                selectionText: 'rows selected',
                                clearSelectionText: 'clear',
                            }"
                            :sort-options="{
                                    enabled: true,
                                    }"
                    >
                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                        <div :key="key">
                            <div v-if="props.column.field == 'action'">
                                <template v-if="canUpdate">
                                    <template v-if="props.row.inv_status != undefined && props.row.inv_status.toLowerCase() == 'draft'">
                                        <template v-if="props.row.origin == 'manual' && props.row.invoice_type_code == 'WO'">
                                            <router-link  title="Edit Work Order Invoice" class="fp-edit" v-bind:to="{name: 'WorkOrderInvoiceEdit',params:{id:props.row.id}}"></router-link>
                                        </template>
                                        <template v-else-if="props.row.origin == 'manual' && props.row.invoice_type_code == 'PE'">
                                            <router-link  title="Edit Permit Invoice" class="fp-edit" v-bind:to="{name: 'PermitInvoiceEdit',params:{id:props.row.id}}"></router-link>
                                        </template>
                                        <template v-else-if="props.row.origin == 'manual' && props.row.invoice_type_code == 'HV'">
                                            <router-link  title="Edit FHUT Invoice" class="fp-edit" v-bind:to="{name: 'HvutInvoiceEdit',params:{id:props.row.id}}"></router-link>
                                        </template>
                                        <template v-else-if="props.row.origin == 'manual' && (props.row.invoice_type_code == 'MC' || props.row.invoice_type_code == 'PS')">
                                            <router-link  title="Edit Invoice" class="fp-edit" v-bind:to="{name: 'InvoiceEdit',params:{id:props.row.id}}"></router-link>
                                        </template>
                                    </template>
                                </template>
                                    <template>
                                        <a href="javascript:void(0)" title="Print Invoice" class="fp-print" v-on:click="printInvoice(props.row.id,props.row.invoice_type_code)"></a>
                                    </template>
                                    &nbsp;
                                    <template>
                                        <a href="javascript:void(0)" title="Download Invoice" class="fp-download" v-on:click="downloadInvoice(props.row.id,props.row.invoice_type_code,props.row.origin,'download')"></a>
                                    </template>
                            </div>
                            <div v-else-if="props.column.field == 'invoice_number' && canView">
                                <template v-if="(props.row.origin == 'manual' || props.row.origin == 'system') && props.row.invoice_type_code == 'WO'">
                                    <router-link  title="View Work Order Invoice" class="color-blue" v-bind:to="{name: 'WorkOrderSalesInvoiceView',params:{id:props.row.id},query:{from:'customer',fromUrl:fromUrl}}">{{props.row.invoice_number}}</router-link>
                                </template>
                                <template v-else-if="props.row.origin == 'manual' && props.row.invoice_type_code == 'PE'">
                                    <router-link  title="View Permit Invoice" class="color-blue" v-bind:to="{name: 'PermitInvoice',params:{id:props.row.id},query:{from:'customer',fromUrl:fromUrl}}">{{props.row.invoice_number}}</router-link>
                                </template>
                                <template v-else-if="props.row.origin == 'manual' && props.row.invoice_type_code == 'HV'">
                                    <router-link  title="View FHUT Invoice" class="color-blue" v-bind:to="{name: 'HvutInvoice',params:{id:props.row.id},query:{from:'customer',fromUrl:fromUrl}}">{{props.row.invoice_number}}</router-link>
                                </template>
                                <template v-else-if="props.row.origin == 'system' && props.row.invoice_type_code == 'PE'">
                                    <router-link  title="View Permit Invoice" class="color-blue" v-bind:to="{name: 'PermitInvoice',params:{id:props.row.id},query:{from:'customer',fromUrl:fromUrl}}">{{props.row.invoice_number}}</router-link>
                                </template>
                                <template v-else-if="props.row.origin == 'system' && props.row.invoice_type_code == 'HV'">
                                    <router-link  title="View FHUT Invoice" class="color-blue" v-bind:to="{name: 'HvutInvoice',params:{id:props.row.id},query:{from:'customer',fromUrl:fromUrl}}">{{props.row.invoice_number}}</router-link>
                                </template>
                                <template v-else-if="props.row.origin == 'system' && props.row.invoice_type_code == 'RC'">
                                    <router-link  title="View Rental Invoice" class="color-blue" v-bind:to="{name: 'RentalAgreementInvoice',params:{id:props.row.id},query:{from:'customer',fromUrl:fromUrl}}">{{props.row.invoice_number}}</router-link>
                                </template>
                                <template v-else-if="props.row.origin == 'manual' && props.row.invoice_type_code == 'RC'">
                                    <router-link  title="View Rental Invoice" class="color-blue" v-bind:to="{name: 'RentalAgreementInvoice',params:{id:props.row.id},query:{from:'customer',fromUrl:fromUrl}}">{{props.row.invoice_number}}</router-link>
                                </template>
                                <template v-else-if="props.row.origin == 'system' && props.row.invoice_type_code == 'LC'">
                                    <router-link  title="View Lease Invoice" class="color-blue" v-bind:to="{name: 'LeaseContractInvoice',params:{id:props.row.id},query:{from:'customer',fromUrl:fromUrl}}">{{props.row.invoice_number}}</router-link>
                                </template>
                                <template v-else-if="props.row.origin == 'manual' && props.row.invoice_type_code == 'LC'">
                                    <router-link  title="View Lease Invoice" class="color-blue" v-bind:to="{name: 'LeaseContractInvoice',params:{id:props.row.id},query:{from:'customer',fromUrl:fromUrl}}">{{props.row.invoice_number}}</router-link>
                                </template>
                                <template v-else-if="props.row.origin == 'system' && props.row.invoice_type_code == 'FB'">
                                    <router-link  title="View Fuel Invoice" class="color-blue" v-bind:to="{name: 'FuelTicketInvoice',params:{id:props.row.id},query:{from:'customer',fromUrl:fromUrl}}">{{props.row.invoice_number}}</router-link>
                                </template>
                                <template v-else-if="props.row.origin == 'system' && props.row.invoice_type_code == 'DP'">
                                    <router-link  title="View Asset Sale Invoice" class="color-blue" v-bind:to="{name: 'AssetSaleInvoiceView',params:{id:props.row.id},query:{from:'customer',fromUrl:fromUrl}}">{{props.row.invoice_number}}</router-link>
                                </template>
                                <template v-else-if="props.row.origin == 'system' && props.row.invoice_type_code == 'CIT'">
                                    <router-link  title="View Citation Invoice" class="color-blue" v-bind:to="{name: 'CitationInvoiceView',params:{id:props.row.id},query:{from:'customer',fromUrl:fromUrl}}">{{props.row.invoice_number}}</router-link>
                                </template>
                                <template v-else-if="props.row.origin == 'system' && props.row.invoice_type_code == 'FIN'">
                                    <router-link  title="View Finance Charge Invoice" class="color-blue" v-bind:to="{name: 'FinanceChargeInvoiceView',params:{id:props.row.id},query:{from:'customer',fromUrl:fromUrl}}">{{props.row.invoice_number}}</router-link>
                                </template>
                                <template v-else-if="props.row.origin == 'manual' && props.row.invoice_type_code == 'PS'">
                                  <router-link  title="View Part Sale Invoice" class="color-blue" v-bind:to="{name: 'PartSaleInvoiceView',params:{id:props.row.id},query:{from:'customer',fromUrl:fromUrl}}">{{props.row.invoice_number}}</router-link>
                                </template>
                                <template v-else-if="props.row.origin == 'manual'">
                                    <router-link  title="View Invoice" class="color-blue" v-bind:to="{name: 'ManualInvoiceView',params:{id:props.row.id},query:{from:'customer',fromUrl:fromUrl}}">{{props.row.invoice_number}}</router-link>
                                </template>
                                <template v-else>
                                    <a href="javascript:void(0)" class="color-blue" v-on:click="selectAction(props.row.id)" title="View Invoice">{{props.row.invoice_number}}</a>
                                </template>
                            </div>
                            <div v-else>
                                <span v-fp-html="props.formattedRow[props.column.field]"></span>
                            </div>
                        </div>
                    </template>
                    <div slot="selected-row-actions">
                        <!-- <button v-if="canDelete && showDeleteBtn" id="deleteInvoiceBtn" v-on:click.prevent="invoiceDelete" class="btn btn-danger">Delete</button> -->
                        <button id="adjustInvoiceBtn" v-on:click.prevent="adjustInvoice" class="btn btn-primary">Adjust</button>
                        <button id="creditInvoiceBtn" v-on:click.prevent="creditInvoice" class="btn btn-primary">Credit</button>

                    </div>
                </vue-good-table>
                <custom-pagination
                        :page-changed="onPageChange"
                        :per-page-changed="onPerPageChange">
                </custom-pagination>
            </div>
        </div>
        <div id="page-content-wrapper" class="admin-content-area" v-else>
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> {{pageTitle}}</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div  class="web-action-btn btn-groups text-right">
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="openModal()" >
                            <i class="fp-import"></i> Import
                        </a>
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
                            <i class="fp-export"></i> Export
                        </a>
                        <a v-if="hideButton === false" href="javascript:void(0)" class="btn btn-secondary" v-on:click="financeChargeInvoice()">
                            Create Finance Charge
                        </a>
                        <a v-if="canSend && sendInvButton && hideButton === false" href="javascript:void(0)" class="btn btn-secondary" v-on:click="sendInvoices()">
                          Send Invoice
                        </a>
                        <a v-if="canConfirm && buttonVis && hideButton === false" href="javascript:void(0)" class="btn btn-secondary" v-on:click="confirmInvoices(false)">
                          Confirm Invoice
                        </a>
                        <a v-if="canUnpost && buttonVis && hideButton === false" href="javascript:void(0)" class="btn btn-secondary" v-on:click="confirmInvoices(true)">
                          Unpost Invoice
                        </a>
                        <a v-if="showBackButton && hideButton === false" href="javascript:void(0)" class="btn btn-secondary" v-on:click="loadAllInvoice()"> <i class="fp-invoice"> </i> All</a>
                        <a v-if="showBackButton && hideButton === false" href="javascript:void(0)" class="btn btn-secondary" v-on:click="backBtn()"> <i class="fp-back"></i>  Back </a>

                        <template v-if="canAdd && hideButton === false">
                            <router-link class="btn btn-primary" v-bind:to="{name: 'InvoiceCreate'}" > <i class="fp-add"> </i> Add</router-link>
                        </template>
                    </div>
                    <div  class="mobile-action-btn elipse-btn">
                        <template v-if="canAdd && hideButton === false">
                            <router-link class="btn btn-primary" v-bind:to="{name: 'InvoiceCreate'}" > <i class="fp-add"> </i> Add</router-link>
                        </template>
                        <template v-if="showBackButton && hideButton === false">
                            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="backBtn()"> <i class="fp-back"></i>  Back </a>
                        </template>
                        <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left" aria-expanded="false" v-on:click.prevent="myFunction">
                            <i class="fp-ellipsis-v"></i>
                        </button>
                        <div id="myDropdown" class="dropdown-content">
                            <ul>
                                <li> <a href="javascript:void(0)" class="" v-on:click="exportCheck()">Export</a> </li>
                                <li><a v-if="hideButton === false" href="javascript:void(0)" class="" v-on:click="financeChargeInvoice()">Post Finance Charge</a></li>
                                <li v-if="canSend && hideButton === false"><a v-if="sendInvButton" href="javascript:void(0)" class="" v-on:click="sendInvoices()">Send Invoice</a></li>
                                <li v-if="canConfirm && hideButton === false"><a v-if="buttonVis" href="javascript:void(0)" class="" v-on:click="confirmInvoices(false)">Confirm Invoice</a></li>
                                <li v-if="canUnpost && hideButton === false"><a v-if="buttonVis" href="javascript:void(0)" class="" v-on:click="confirmInvoices(true)">Unpost Invoice</a></li>
                                <li v-if="showBackButton &&  hideButton === false"><a href="javascript:void(0)" class="btn btn-secondary" v-on:click="loadAllInvoice()">  All</a></li>

                            </ul>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content invoice-list">
                        <div class="btn-groups badge-buttons text-left mb-3">
                            <div class="">
                                <div id="divTabMenu" class="btn-group rental-btn-grup-left" role="group" aria-label="Basic example">
                                    <button type="button" id="getAllCustomerInvoices" v-on:click="getAllCustomerInvoices(this)" :class="'btn btn-secondary '+ allActive"> All <span>{{ allCount }} </span> </button>
                                    <button type="button" id="getEnteredCustomerInvoices" v-on:click="getDraftCustomerInvoices(this)" :class="'btn btn-secondary '+ draftActive"> Draft <span> {{  draftCount }} </span> </button>
                                    <button type="button" id="getVerifiedCustomerInvoices" v-on:click="getBilledCustomerInvoices(this)" :class="'btn btn-secondary '+ billedActive"> Billed <span> {{ billedCount }} </span> </button>
                                    <button type="button" id="getApprovedCustomerInvoices" v-on:click="getSentCustomerInvoices(this)" :class="'btn btn-secondary '+ sentActive"> Sent <span> {{ sentCount }}</span> </button>
                                    <button type="button" id="getApprovedCustomerInvoices" v-on:click="getPaidCustomerInvoices(this)" :class="'btn btn-secondary '+ paidActive"> Paid <span> {{ paidCount }}</span> </button>
                                    <button type="button" id="getDeletedCustomerInvoices" v-on:click="getDeletedCustomerInvoices(this)" :class="'btn btn-secondary '+ deletedActive"> Deleted <span> {{ deletedCount }}</span> </button>
                                </div>
                            </div>
                        </div>
                        <data-table-filter-config :moduleName="'invoiceList'" ref="filterInvoice" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                        <p v-if="batchProcess1" class="alert-success p-2">Current batch {{batchNum1}} is processing please wait!</p>
                        <p v-if="batchProcess2" class="alert-success p-2">{{fin_batch_msg}}</p>
                        <p v-if="batchProcess3" class="alert-success p-2">{{confirmInvoiceMsg}}</p>
                        <p v-if="batchError" class="alert-danger p-2" id="processErrorBatchMsg">{{batchErrorMsg}}<button type="button" class="close close-alert" v-on:click="batchError = false;batchErrorMsg = ''">×</button></p>
                        <section class="data-table bg-white">
                            <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'invoiceList'" :position="'top'">
                            </custom-pagination>
                            <vue-good-table
                                    mode="remote"
                                    ref="invoiceList"
                                    title="Invoices"
                                    @on-page-change="onPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    @on-select-all="onSelectAll"
                                    :rows="rows"
                                    :isLoading=false
                                    :paginationOptions="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false

                                    }"
                                    :select-options="{
                                        enabled: invoice_value,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }"

                                    :sort-options="{
                                    enabled: true,
                                    }"
                            >
                                <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                    <div :key="key">
                                        <div v-if="props.column.field == 'action'">
                                            <template v-if="canUpdate && props.row.deleted_at == null">
                                                <template v-if="props.row.inv_status != undefined && props.row.inv_status.toLowerCase() == 'draft'">
                                                    <template v-if="props.row.origin == 'manual' && props.row.invoice_type_code == 'WO' && props.row.enrich_id == null">
                                                        <router-link  title="Edit Work Order Invoice" class="fp-edit" v-bind:to="{name: 'WorkOrderInvoiceEdit',params:{id:props.row.id}}"></router-link>
                                                    </template>
                                                    <template v-else-if="props.row.origin == 'manual' && props.row.invoice_type_code == 'PE' && props.row.enrich_id == null">
                                                        <router-link  title="Edit Permit Invoice" class="fp-edit" v-bind:to="{name: 'PermitInvoiceEdit',params:{id:props.row.id}}"></router-link>
                                                    </template>
                                                    <template v-else-if="props.row.origin == 'manual' && props.row.invoice_type_code == 'HV' && props.row.enrich_id == null">
                                                        <router-link  title="Edit FHUT Invoice" class="fp-edit" v-bind:to="{name: 'HvutInvoiceEdit',params:{id:props.row.id}}"></router-link>
                                                    </template>
                                                    <template v-else-if="props.row.origin == 'manual' && props.row.invoice_type_code == 'MC' && props.row.enrich_id == null">
                                                        <router-link  title="Edit Invoice" class="fp-edit" v-bind:to="{name: 'InvoiceEdit',params:{id:props.row.id}}"></router-link>
                                                    </template>
                                                </template>
                                            </template>
                                        </div>
                                        <div v-else-if="props.column.field == 'invoice_number' && canView">
                                            <template v-if="(props.row.origin == 'manual' || props.row.origin == 'system') && props.row.invoice_type_code == 'WO'">
                                                <router-link  title="View Work Order Invoice" class="color-blue" v-bind:to="{name: 'WorkOrderSalesInvoiceView',params:{id:props.row.id}}">{{props.row.invoice_number}}</router-link>
                                            </template>
                                            <template v-else-if="props.row.origin == 'manual' && props.row.invoice_type_code == 'PE'">
                                                <router-link  title="View Permit Invoice" class="color-blue" v-bind:to="{name: 'PermitInvoice',params:{id:props.row.id}}">{{props.row.invoice_number}}</router-link>
                                            </template>
                                            <template v-else-if="props.row.origin == 'manual' && props.row.invoice_type_code == 'HV'">
                                                <router-link  title="View FHUT Invoice" class="color-blue" v-bind:to="{name: 'HvutInvoice',params:{id:props.row.id}}">{{props.row.invoice_number}}</router-link>
                                            </template>
                                            <template v-else-if="props.row.origin == 'system' && props.row.invoice_type_code == 'PE'">
                                                <router-link  title="View Permit Invoice" class="color-blue" v-bind:to="{name: 'PermitInvoice',params:{id:props.row.id}}">{{props.row.invoice_number}}</router-link>
                                            </template>
                                            <template v-else-if="props.row.origin == 'system' && props.row.invoice_type_code == 'HV'">
                                                <router-link  title="View FHUT Invoice" class="color-blue" v-bind:to="{name: 'HvutInvoice',params:{id:props.row.id}}">{{props.row.invoice_number}}</router-link>
                                            </template>
                                            <template v-else-if="props.row.origin == 'system' && props.row.invoice_type_code == 'RC'">
                                                <router-link  title="View Rental Invoice" class="color-blue" v-bind:to="{name: 'RentalAgreementInvoice',params:{id:props.row.id}}">{{props.row.invoice_number}}</router-link>
                                            </template>
                                            <template v-else-if="props.row.origin == 'manual' && props.row.invoice_type_code == 'RC'">
                                                <router-link title="View Rental Invoice" class="color-blue" v-bind:to="{name: 'RentalAgreementInvoice',params:{id:props.row.id},query:{from:'customer',fromUrl:fromUrl}}">{{props.row.invoice_number}}</router-link>
                                            </template>
                                            <template v-else-if="props.row.origin == 'system' && props.row.invoice_type_code == 'LC'">
                                                <router-link  title="View Lease Invoice" class="color-blue" v-bind:to="{name: 'LeaseContractInvoice',params:{id:props.row.id}}">{{props.row.invoice_number}}</router-link>
                                            </template>
                                            <template v-else-if="props.row.origin == 'manual' && props.row.invoice_type_code == 'LC'">
                                                <router-link  title="View Lease Invoice" class="color-blue" v-bind:to="{name: 'LeaseContractInvoice',params:{id:props.row.id}}">{{props.row.invoice_number}}</router-link>
                                            </template>
                                            <template v-else-if="props.row.origin == 'system' && props.row.invoice_type_code == 'FB'">
                                                <router-link  title="View Fuel Invoice" class="color-blue" v-bind:to="{name: 'FuelTicketInvoice',params:{id:props.row.id}}">{{props.row.invoice_number}}</router-link>
                                            </template>
                                            <template v-else-if="props.row.origin == 'system' && props.row.invoice_type_code == 'FIN'">
                                                <router-link  title="View Finance Charge Invoice" class="color-blue" v-bind:to="{name: 'FinanceChargeInvoiceView',params:{id:props.row.id}}">{{props.row.invoice_number}}</router-link>
                                            </template>
                                            <template v-else-if="props.row.origin == 'system' && props.row.invoice_type_code == 'DP'">
                                                 <router-link  title="View Asset Sale Invoice" class="color-blue" v-bind:to="{name: 'AssetSaleInvoiceView',params:{id:props.row.id}}">{{props.row.invoice_number}}</router-link>
                                            </template>
                                            <template v-else-if="props.row.origin == 'system' && props.row.invoice_type_code == 'CIT'">
                                                <router-link  title="View Citation Invoice" class="color-blue" v-bind:to="{name: 'CitationInvoiceView',params:{id:props.row.id}}">{{props.row.invoice_number}}</router-link>
                                            </template>
                                            <template v-else-if="props.row.origin == 'manual' && props.row.invoice_type_code == 'PS'">
                                              <router-link  title="View Part Sale Invoice" class="color-blue" v-bind:to="{name: 'PartSaleInvoiceView',params:{id:props.row.id},query:{from:'customer',fromUrl:fromUrl}}">{{props.row.invoice_number}}</router-link>
                                            </template>
                                            <template v-else-if="props.row.origin == 'manual'">
                                                <router-link  title="View Invoice" class="color-blue" v-bind:to="{name: 'ManualInvoiceView',params:{id:props.row.id}}">{{props.row.invoice_number}}</router-link>
                                            </template>
                                            <template v-else>
                                                <a href="javascript:void(0)" class="color-blue" v-on:click="selectAction(props.row.id)" title="View Invoice">{{props.row.invoice_number}}</a>
                                            </template>
                                        </div>
                                        <div v-else>
                                            <span v-fp-html="props.formattedRow[props.column.field]"></span>
                                        </div>
                                    </div>
                                </template>
                                <div slot="selected-row-actions">
                                    <button v-if="canDelete && showDeleteBtn" id="deleteInvoiceBtn" v-on:click.prevent="invoiceDelete" class="btn btn-danger">Delete</button>
                                    <button id="creditInvoiceBtn" v-on:click.prevent="creditInvoice" class="btn btn-primary">Credit</button>
                                </div>

                            </vue-good-table>
                            <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                            </custom-pagination>
                        </section>
                        <div class="modal fade billed-invoice-message-modal" id="billed-invoice-message-modal" ref="billedInvoiceMessageModal" data-backdrop="static" data-keyboard="false" aria-labelledby="billedInvoiceMessageModal" aria-hidden="true">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title">Message</h5>
                                            <button type="button" class="close" id="btnModalMessageClose" v-on:click="hideMessageModal()">&times;</button>
                                        </div>
                                        <div class="modal-body">
                                          <template v-if="billedInvoicesArr.length">
                                            <p v-show="statusMessageError">Following invoices already billed : </p>
                                                <template v-for="(inv,key) in billedInvoicesArr">
                                                    <a :key="'i' + key" v-if="key > 0">&nbsp;&nbsp; | &nbsp;&nbsp;</a><span :key="'j' + key"> {{inv}}</span>
                                                </template>
                                            </template>
                                          <template v-if="draftedInvoicesArr.length">
                                            <p v-show="statusMessageError">Following invoices are not billed hence, cannot be un-posted : </p>
                                            <template v-for="(inv,key) in draftedInvoicesArr">
                                              <a :key="'i' + key" v-if="key > 0">&nbsp;&nbsp; | &nbsp;&nbsp;</a><span :key="'j' + key"> {{inv}}</span>
                                            </template>
                                          </template>
                                          <template v-if="draftedWoInvoicesArr.length">
                                            <p v-show="statusMessageError">Following work order invoices will not be confirmed as WO is not yet approved : </p>
                                            <template v-for="(inv,key) in draftedWoInvoicesArr">
                                              <a :key="'i' + key" v-if="key > 0">&nbsp;&nbsp; | &nbsp;&nbsp;</a><span :key="'j' + key"> {{inv}}</span>
                                            </template>
                                          </template>
                                        </div>
                                        <div class="modal-footer">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        <div class="modal fade ifta-upload-modal" id="ifta-upload-modal" ref="ifta-upload-modal" data-backdrop="static" data-keyboard="false" aria-labelledby="ifta-upload-modal" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Select File</h5>
                                    </div>
                                    <div class="modal-body">
                                        <form id="importIFTAFile" class="addinspectionForm">
                                            <div class="form-row">
                                                <div class="col form-group">
                                                    <label class="control-label require mb-2" for="name">File:</label><br/>
                                                    <input id="iftaUploadFile" type="file" @change="onFileChanged">
                                                    <div class="field-error">{{import_error}}</div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col form-group" v-if="fileName != ''">
                                                    <label class="control-label"> Download Sample file </label>
                                                    <a href="javascript:void(0)" v-on:click="downloadSample()"> <i class="fp-text-document"></i> {{fileName}} </a>
                                                </div>
                                            </div>
                                            <p v-if="duplicateInvoice.unit != undefined || duplicateInvoice.customer != undefined || duplicateInvoice.amount != undefined
                                                || duplicateInvoice.date_validate != undefined || duplicateInvoice.charge_code != undefined">&nbsp;</p>
                                            <template v-if="duplicateInvoice.unit && duplicateInvoice.unit.length > 0">
                                                <label class="d-block"> Invoice Not Imported Because These Unit Not Available:</label>
                                                <template v-for="(asset,assetKey) in duplicateInvoice.unit">
                                                    <a :key="assetKey" v-if="assetKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="assetKey">{{asset.unit_number}}</span>
                                                </template>
                                                <p>&nbsp;</p>
                                            </template>
                                            <template v-if="duplicateInvoice.customer && duplicateInvoice.customer.length > 0">
                                                <label class="d-block"> Invoice Not Imported Because These Customer Not Available:</label>
                                                <template v-for="(cust,custKey) in duplicateInvoice.customer">
                                                    <a :key="custKey" v-if="custKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="custKey">{{cust.customer_number}}</span>
                                                </template>
                                                <p>&nbsp;</p>
                                            </template>
                                            <template v-if="duplicateInvoice.amount && duplicateInvoice.amount.length > 0">
                                                <label class="d-block"> Invoice Not Imported Because Amount For These Unit Not Available:</label>
                                                <template v-for="(amt,amtKey) in duplicateInvoice.amount">
                                                    <a :key="amtKey" v-if="amtKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="amtKey">{{amt.unit_number}}</span>
                                                </template>
                                                <p>&nbsp;</p>
                                            </template>
                                            <template v-if="duplicateInvoice.date_validate && duplicateInvoice.date_validate.length > 0">
                                                <label class="d-block"> Invoice Not Imported Because These Unit End Date Is Earlier Than Start Date:</label>
                                                <template v-for="(dt,dtKey) in duplicateInvoice.date_validate">
                                                    <a :key="dtKey" v-if="dtKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="dtKey">{{dt.unit_number}}</span>
                                                </template>
                                                <p>&nbsp;</p>
                                            </template>
                                            <template v-if="duplicateInvoice.charge_code && duplicateInvoice.charge_code.length > 0">
                                                <label class="d-block"> Invoice Not Imported Because Charge Code For These Unit Not Available:</label>
                                                <template v-for="(cc,ccKey) in duplicateInvoice.charge_code">
                                                    <a :key="ccKey" v-if="ccKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="ccKey">{{cc.unit_number}}</span>
                                                </template>
                                                <p>&nbsp;</p>
                                            </template>
                                        </form>

                                        <div class="modal-footer">
                                            <button class="btn btn-tertiary" id="cancelButton" data-dismiss="modal"> <i class="fp-close"> </i>Cancel</button>
                                            <button class="btn btn-primary" id="importButton" v-on:click="importInvoices()"> <i class="fp-import"> </i> Import</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal fade sub-system-inv-modal" id="sub-system-inv-modal" ref="subSystemInvModal" data-backdrop="static" data-keyboard="false" aria-labelledby="subSystemInvModal" aria-hidden="true">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Message</h5>
                                        <button type="button" class="close" id="btnSubSysInvModalClose" v-on:click="hideSubSysMsgModal()">&times;</button>
                                    </div>
                                    <div class="modal-body">
                                        <p class="color-red">Subsystem A/R DIRECT ENTRY has been closed.</p>
                                        <p>Are you sure that you want to confirm following Invoices ? </p>
                                        <template v-if="subSystemInvArr.length">
                                            <template v-for="(inv,inv_key) in subSystemInvArr">
                                                <template v-if="inv_key > 0">
                                                    <a :key="'inv_no' + inv_key">&nbsp;&nbsp; | &nbsp;&nbsp;</a><span :key="'inv_no' + inv_key"> {{inv.invoice}}</span>
                                                </template>
                                                <template v-else>
                                                    <span :key="'inv_no' + inv_key"> {{inv.invoice}}</span>
                                                </template>
                                            </template>
                                        </template>
                                    </div>
                                    <div class="modal-footer">
                                        <button class="btn btn-primary" id="btnSubSysInvModalOk" :disabled="okDisableForSS" v-on:click="confirmSubSysInvoice()"> Ok </button>
                                        <button class="btn btn-tertiary" id="btnSubSysInvModalCancel" v-on:click="hideSubSysMsgModal()"> Cancel </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
            <div class="modal fade invoice-modal" id="myModal" ref="myModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Invoices with the status DRAFT</h5>
                        </div>
                        <div class="modal-body">
                            <p>Please confirm following invoices before sending to the customer</p>
                            <form id="SelectDates" class="form-inline addinspectionForm">
                                <template v-for="(st , key) in invdraftStatus" class="tab-truck-select-right">
                                    <div :key="key">Invoice Number : &nbsp;&nbsp;{{st}}</div>
                                </template>
                            </form>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" data-dismiss="modal">Ok</button>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</template>


<script>

    import Vue from 'vue';
    import EventBus from ".././event-bus";
    import VueSSE from 'vue-sse'
    Vue.use(VueSSE);
    import {commonMixins} from '../../mixins/commonMixins';
    import {dataTableMixins} from '../../mixins/dataTableMixins';
    let msgServer
    export default {
        name: "InvoicesList",
        mixins:[commonMixins,dataTableMixins],
        props: {
            listFlag: {
                 type: String,
                 required: false,
                 default:undefined
             },
            customerId: {
                type: String,
                required: false,
                default:undefined
            }
        },
        data: () => ({
            isShowFilter: true,
            pageTitle:"Customer Invoice List",
            invoice_value:true,
            action: this.listFlag,
            firstLoad: 0,
            userRole:"",
            showBackButton:false,
            permissions: [],
            invdraftStatus:[],
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    html: true,
                    sortable: false,

                },
                {
                    label: "#Invoice",
                    field: "invoice_number",
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Invoice", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "Batch Id",
                    field: "batch_id",
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Batch Id", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                 {
                    label: "Source",
                    field: "inv_type",
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Source", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "Customer",
                    field: "customer",
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customers", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "Customer Emails",
                    field: "customer_emails",
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    html: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customers Emails", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                {
                    label: "Invoice Amount",
                    field: "amount",
                    fpFieldType:"integer",
                    hidden:false,
                    filterable: true,
                    type: 'number',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Invoice Amount", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "Open Invoice Amount",
                    field: "current_open_inv_amount",
                    fpFieldType:"integer",
                    hidden:false,
                    filterable: true,
                    type: 'number',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Open Invoice Amount", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "Applied Payment",
                    field: "applied_payment",
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Applied Payment", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "Status",
                    field: "inv_status",
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true,
                    // type: 'number',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ["Draft", "Billed","Sent","Paid"], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "Action By",
                    field: "action_by",
                    hidden:false,
                    filterable: true,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Action By", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "Invoice Date",
                    field: "invoice_date",
                    hidden:false,
                    fpFieldType:"date",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "Created Date",
                    field: "created_at",
                    hidden:false,
                    fpFieldType:"date",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            invoice_id:0,
            loading:false,
            cantAccessPage:"",
            canView:false,
            buttonVis:false,
            canAdd:false,
            canUpdate:false,
            canConfirm:false,
            canSend:false,
            hideButton:false,
            batchId:0,
            batchProcess1:false,
            sendInvButton:false,
            batchNum1:'',
            billedInvoicesArr:[],
            statusMessageError:false,
            pageKey:"_invoice_list_",
            fromUrl:"",
            selectedFile:"",
            file:'',
            import_error:'',
            fileName:'',
            duplicateInvoice:[],
            canDelete:false,
            showDeleteBtn:false,
            batchProcess:0,
            batchNum:"",
            subSystemFlag:"",
            subSystemInvArr:[],
            batchError:false,
            batchErrorMsg:"",
            batchProcess2:false,
            confirmInvoiceMsg:'',
            batchNum2:'',
            fin_batch_msg:'',
            batchProcess3:false,
            batchNum3:'',
            okDisableForSS:false,
            canUnpost: false,
            isUnpost: false,
            draftedInvoicesArr: [],
            draftedWoInvoicesArr: [],
            allActive:'',
            draftActive: '',
            billedActive: '',
            sentActive: '',
            paidActive: '',
            deletedActive: '',
            status_flag:'all',
            allCount:0,
            draftCount:0,
            billedCount:0,
            sentCount:0,
            paidCount:0,
            deletedCount:0,
        }),
        metaInfo () {
            if (this.customerId == undefined) {
                return {
                    title: "Customer Invoice List | " +process.env.COPYRIGHT_NAME
                }
            }
        },
        watch:{
            permissions: function(permission){
                var self = this;
                permission.forEach(function (permissions) {
                    if(permissions.name == 'list_invoice') {
                        self.cantAccessPage = true;
                    }
                    if(permissions.name == 'view_invoice') {
                        self.canView = true;
                    }
                    if(permissions.name == 'add_invoice') {
                        self.canAdd = true;
                        self.canUpdate = true;
                    }
                    if(permissions.name == 'confirm_invoice') {
                        self.canConfirm = true;
                    }
                    if(permissions.name == 'send_invoice') {
                        self.canSend = true;
                    }
                    if(permissions.name == 'delete_invoice') {
                        self.canDelete = true;
                    }
                    if (permissions.name == 'unpost_gl'){
                      self.canUnpost = true;
                    }
                });
                if(self.cantAccessPage == ''){
                    self.cantAccessPage = false;
                }
            },

        },
        created : function () {
            let self = this;
            
        },

        mounted: function() {

            var self = this;
            self.getPermissions();
            if (self.$route.query.flag != undefined) {
                this.showBackButton = true;
            }
            self.fromUrl = btoa(window.location.pathname);
            // if(self.$route.query.flag == 'disposal'){
            //   self.hideButton = true;
            //   self.pageTitle = "Disposal Invoice Listing";
            //   self.invoice_value = false;
            //   for (let index = 0; index < this.columns.length; index++) {

            //       if(this.columns[index].field == 'action'){
            //           this.$set(this.columns[index], 'hidden', true);
            //       }
            //       if(this.columns[index].field == 'inv_type'){
            //           this.$set(this.columns[index], 'hidden', true);
            //       }
            //   }
            // }

            if(self.$route.query.flag == 'refund_invoice'){
              self.hideButton = true;
              self.pageTitle = "Invoice Listing";
              self.invoice_value = false;
              self.isShowFilter = false;
              for (let index = 0; index < this.columns.length; index++) {

                  if(this.columns[index].field == 'action'){
                      this.$set(this.columns[index], 'hidden', true);
                  }
                  if(this.columns[index].field == 'inv_type'){
                      this.$set(this.columns[index], 'hidden', true);
                  }
              }
            } else {
              self.isShowFilter = true;
            }

            if(self.$route.query.flag == 'invoiceReport'){
              self.hideButton = true;
              self.pageTitle = "Invoice Listing";
              self.invoice_value = false;
              for (let index = 0; index < this.columns.length; index++) {

                  if(this.columns[index].field == 'action'){
                      this.$set(this.columns[index], 'hidden', true);
                  }
                  // if(this.columns[index].field == 'inv_type'){
                  //     this.$set(this.columns[index], 'hidden', true);
                  // }
              }
            }

            if ( self.customerId == undefined ) {

            } else {
                if ( self.listFlag == "customerInvoice" ) {
                    for (let index = 0; index < this.columns.length; index++) {

                        if(this.columns[index].field == 'customer'){
                            this.$set(this.columns[index], 'hidden', true);
                        }
                    }
                }

            }
            if (self.$route.query.from == 'fin_post'){
                self.batchId = self.$route.query.batch_id;
                self.batchNum2 = self.$route.query.num;
                self.batchProcess2 = true;
                self.fin_batch_msg = 'Current batch'+ self.batchNum2+ ' for finance charge is processing please wait!';
                self.checkBatchStatus();
            }
            $('#divTabMenu button').removeClass("active");
            var prevSelectedTab = localStorage.getItem("customer_list_prev_tab");

            if ( prevSelectedTab == null ) {

                self.status_flag = "all";
                self.allActive = 'active';
                localStorage.setItem('customer_list_prev_tab', 'all');

            } else {

                if ( prevSelectedTab == 'draft' ) {

                    self.status_flag = "draft";
                    self.draftActive = 'active';

                } else if ( prevSelectedTab == 'billed' ) {

                    self.status_flag = "billed";
                    self.billedActive = 'active';

                }else if(prevSelectedTab ==  'sent'){

                    self.status_flag = "sent";
                    self.sentActive = 'active';

                }else if(prevSelectedTab ==  'paid'){

                    self.status_flag = "paid";
                    self.paidActive = 'active';

                }else if(prevSelectedTab == 'deleted'){

                    self.status_flag = 'deleted';
                    self.deletedActive = 'active';

                } else {

                    self.status_flag = "all";
                    self.allActive = 'active';
                }
            }

        },
        beforeDestroy() {
        // Make sure to close the connection with the events server
        // when the component is destroyed, or we'll have ghost connections!
            msgServer.close();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.invoiceList.unselectAllInternal();
            },
            exportCheck: function() {
                var count = 0;
                var actionFlag = "";
                var data = this.$refs['invoiceList'].selectedRows;
                count = data.length;
                if(this.serverParams.selectedAll == true){
                    actionFlag = "";
                }else if(count != 0 && count <= 100){
                    actionFlag = "export";
                }
                this.exportReports(actionFlag);
            },
            checkBatchStatus:function(){
                var self =  this;

                //  $.ajax({
                //     url: process.env.ROOT_API + "/check/batch-status/"+self.batchId,
                //     type: "GET",
                //     crossDomain: true,
                //     headers: {
                //         'Accept': 'application/json',
                //         "Authorization": "Bearer "+localStorage.getItem("tkn"),
                //         'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                //         "Cache-Control": "no-cache"
                //     },
                //     success: function(data) {
                //         self.loading = false;

                //         window.Echo.channel('batchStatus').listen('BatchStatusEvent', (e) => {
                //             console.log(e);
                //             if (e.status && (e.status == 1 || e.status == 2) ){
                //                 self.batchProcess1 = false;
                //                 self.loadList();
                //             }
                //         });
                //     },
                //     error: function(jqXHR, exception) {
                //         self.loading = false;
                //         self.generateStatusCodeMessage(jqXHR,false,'invoice-list');
                //     }
                // });

                this.$sse(process.env.ROOT_API + '/check/batch-status/'+self.batchId, { format: 'json' }) // or { format: 'plain' }
                .then(sse => {
                    // Store SSE object at a higher scope
                    msgServer = sse;

                    // Listen for messages without a specified event
                    sse.subscribe('', data => {
                        if ( data.status == "1") {
                            if (data.type != undefined && data.type == 'finance_charge'){
                                self.fin_batch_msg = 'Finance charges are created successfully';
                                setTimeout(function(){
                                    self.fin_batch_msg = '';
                                    self.batchProcess2 = false;
                                    self.$router.push('/invoice/list');
                                },4000);
                            }else if (data.type != undefined && data.type == 'confirm_invoice'){
                                if (self.isUnpost == true){
                                  self.confirmInvoiceMsg = 'Invoices un-posted successfully';
                                }else{
                                  self.confirmInvoiceMsg = 'Invoices confirmed successfully';
                                }
                                setTimeout(function(){
                                    self.confirmInvoiceMsg = '';
                                    self.batchProcess3 = false;
                                    self.batchNum3 = '';
                                    // self.$router.push('/invoice/list');
                                },4000);
                            }else{
                                self.batchProcess1 = false;
                            }
                            self.loadList();
                            sse.close();
                        }else if (data.status == "2") {
                            if (data.type != undefined && data.type == 'finance_charge'){
                                self.batchProcess2 = false;
                                self.fin_batch_msg = 'Finance charges are not created';
                            }if (data.type != undefined && data.type == 'confirm_invoice'){
                                self.batchProcess3 = false;
                                self.confirmInvoiceMsg = 'Invoice Not Confirmed';
                            }else{
                                self.batchProcess1 = false;
                            }
                            self.batchError = true;
                            self.batchErrorMsg = data.message;
                            sse.close();
                        }
                    });

                })
                .catch(err => {
                    // When this error is caught, it means the initial connection to the
                    // events server failed.  No automatic attempts to reconnect will be made.
                    console.error('Failed to connect to server', err);
                });

            },
            loadAllInvoice:function () {
                this.$router.push("/invoice/list");
                this.loadList();
            },
            selectAction: function(id){
                var self = this;
                if(self.customerId != undefined){
                  if(this.$route.query.paymentId != undefined) {
                    self.$router.push("/invoice/view/" + id + "?paymentId=" + this.$route.query.paymentId + "&flag=paymentlist");
                  } else {
                      self.$router.push("/invoice/view/"+id+"?from=customer"+"&fromUrl="+self.fromUrl);
                  }
                }else{
                  if(this.$route.query.paymentId != undefined) {
                    self.$router.push("/invoice/view/" + id + "?paymentId=" + this.$route.query.paymentId + "&flag=paymentlist");
                  } else {
                      self.$router.push("/invoice/view/"+id);
                  }
                }

            },
            // loadList is what brings back the rows from server
            loadList: function() {
                var self = this;
                if(self.customerId != undefined)
                {
                    $('#dataTableFilterConfig').removeClass('col-md-12 filter-section-main')
                }

                var date = new Date();
                var offset = date.getTimezoneOffset();
                var selectedCust;
                if(self.action=='sendInvoice') {
                    var rowData = self.$refs['invoiceList'].selectedRows;

                    for (var i = 0; i < rowData.length; i++) {
                        var invIdArr = [];
                        invIdArr.push(this.$refs['invoiceList'].selectedRows[i].id)
                        if (rowData[i].inv_status.toLowerCase() == 'draft') {
                            self.$swal('','Cannot send invoice with draft status','info');
                            return;
                        }
                    }

                    selectedCust = invIdArr;
                }else if(self.action=='confirmInvoice'){
                    if (self.subSystemFlag != "") {
                        var invIdArr = [];
                        for (var i = 0; i < self.subSystemInvArr.length; i++) {
                            if (self.subSystemInvArr[i].id != undefined && self.subSystemInvArr[i].id != null) {
                                invIdArr.push(self.subSystemInvArr[i].id);
                            }
                        }
                        selectedCust=invIdArr;
                    }else{
                        var rowData = self.$refs['invoiceList'].selectedRows;
                        var invIdArr = [];
                        for (var i = 0; i < rowData.length; i++) {
                            invIdArr.push(this.$refs['invoiceList'].selectedRows[i].id)
                        }
                        selectedCust=invIdArr;
                    }
                }else if(self.action == 'deleteInvoice'){
                    var rowData = self.$refs['invoiceList'].selectedRows;
                    var invIdArr = [];
                    for (var i = 0; i < rowData.length; i++) {
                        invIdArr.push(this.$refs['invoiceList'].selectedRows[i].id)
                    }
                    selectedCust = invIdArr;
                }else if(self.action == 'export' || self.action == 'export_queue'){

                }else{
                    selectedCust=self.customerId;
                    self.action=self.listFlag;
                }

                var selectedRows = [];

                //because on first load list not initialize
                var data = self.$refs['invoiceList'].selectedRows;
                for ( var i = 0; i < data.length; i++ ) {
                    selectedRows.push(self.$refs['invoiceList'].selectedRows[i].id)
                }

                self.loading = true;
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/invoice/list",
                    type: "POST",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: this.serverParams.columnFilters,
                        sort: this.serverParams.sort,
                        offset: offset,
                        paymentId: this.$route.query.paymentId,
                        selectedAll: self.serverParams.selectedAll,
                        flag: self.action,
                        id: selectedCust,
                        selectedRows: selectedRows,
                        subSystemFlag: self.subSystemFlag,
                        isReverse: self.isUnpost,
                        status_flag: self.status_flag,

                    },
                    success: function(data) {
                        self.loading = false;
                        if (data.status == "success") {
                            if(data.content.row != undefined) {
                                self.rows = data.content.row;
                            }
                            if(data.content.totalRecords == 0){
                                self.rows = [];
                            }
                            self.totalRecords = data.content.totalRecords;
                            if ( self.action == "export" ||  self.action == "export_queue") {
                              if ( data.code == "201" ) {
                                  alert(data.message);
                              } else {
                                  if ( self.action == "export" ) {
                                      self.excel = data.content.web;
                                      var save = document.createElement("a");
                                      save.href = self.excel;
                                      save.download = data.content.web;
                                      save.target = "_blank";

                                      document.body.appendChild(save);
                                      save.click();
                                      document.body.removeChild(save);

                                  } else {

                                      self.batchProcess = 1;
                                      self.batchNum = data.content;
                                  }
                              }
                              self.action = "";
                              self.listFlag = "";
                              self.loadList();
                            }
                            if(self.action=='sendInvoice') {
                                self.action = "";

                                self.$refs.filterInvoice.clearSelectAll();

                                // if (data.code == 201 && data.content.length > 0) {
                                //     $("#myModal").modal('show');
                                //     self.invdraftStatus = data.content;
                                // } else {
                                    self.$swal('', 'Invoices Sent', 'success');
                                // }
                                EventBus.$emit('clear-all-flags', false);
                                self.batchId = data.batch;
                                self.batchNum1 = data.batchNumber;
                                self.batchProcess1 = true;
                                self.checkBatchStatus();
                                self.loadList();
                                return;
                            }
                            if(self.action=='confirmInvoice'){
                                if (data.already_billed && data.already_billed.length > 0){
                                    self.statusMessageError = true;
                                    self.billedInvoicesArr = data.already_billed;
                                    $("#billed-invoice-message-modal").modal("show");
                                }else if (data.only_drafted && data.only_drafted.length > 0){
                                  self.statusMessageError = true;
                                  self.draftedInvoicesArr = data.only_drafted;
                                  $("#billed-invoice-message-modal").modal("show");
                                }else if(data.only_draftedWo && data.only_draftedWo.length > 0){
                                  self.statusMessageError = true;
                                  self.draftedWoInvoicesArr = data.only_draftedWo;
                                  $("#billed-invoice-message-modal").modal("show");
                                }else{
                                    if (data.content != '') {
                                        if (data.content.sub_msg != undefined && data.content.sub_msg != '') {
                                            self.subSystemInvArr = [];
                                            if (data.content.inv_arr != undefined) {
                                                if (data.content.inv_arr.length > 0) {
                                                    self.subSystemInvArr = data.content.inv_arr;
                                                    $("#sub-system-inv-modal").modal("show");
                                                    self.okDisableForSS = true;
                                                    //to load list first then allow to submit confirm invoice again
                                                    setTimeout(function(){
                                                        self.okDisableForSS = false;
                                                    },2000);
                                                }
                                            }
                                        }else{
                                            self.subSystemInvArr = [];
                                            if (self.isUnpost){
                                              self.$swal('','Invoices Un-posted','success');
                                            }else{
                                              self.$swal('','Invoices Confirmed','success');
                                            }
                                        }
                                    }
                                }
                                self.subSystemFlag = "";
                                self.action = "";
                                self.$refs.filterInvoice.clearSelectAll();
                                EventBus.$emit('clear-all-flags', false);

                                if (data.batch_id != undefined){
                                    self.batchId = data.batch_id;
                                    self.batchNum3 = data.batch;
                                    self.batchProcess3 = true;
                                    if (self.isUnpost){
                                      self.confirmInvoiceMsg = 'Current batch'+ self.batchNum3+ ' for un-posting invoice is processing please wait!';
                                    }else{
                                      self.confirmInvoiceMsg = 'Current batch'+ self.batchNum3+ ' for confirm invoice is processing please wait!';
                                    }
                                    self.checkBatchStatus();
                                }
                                    self.loadList();

                                return;
                            }
                            if(self.action == 'deleteInvoice'){
                                self.action = "";
                                self.$refs.filterInvoice.clearSelectAll();
                                EventBus.$emit('clear-all-flags', false);
                                //message with invoice number if invoice not deleted
                                if (data.content.invoices != undefined && data.content.invoices != null) {
                                    if (data.content.invoices != "") {
                                        self.$swal('',data.content.invoices,'info');
                                    }
                                }
                                self.loadList();
                                return;
                            }

                            self.getCount();
                        }
                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'invoice-list');
                    }
                });


            },
            selectionChanged(param) {

                var self = this;
                var rowData = self.$refs['invoiceList'].selectedRows;
                var selectedStatusArr = [];
                if(rowData.length > 0){

                    self.buttonVis = true;
                    for(var i = 0;i<rowData.length;i++){
                        selectedStatusArr.push(rowData[i].inv_status.toLowerCase());
                    }

                    //check all values in array are equal or not
                    const allEqual = arr => arr.every( v => v === arr[0] );
                    var draftFound = allEqual(selectedStatusArr);

                    if (draftFound && selectedStatusArr.includes("draft")) {
                        self.sendInvButton = false;
                        self.showDeleteBtn = true;
                    }else{
                        self.sendInvButton = true;
                        self.showDeleteBtn = false;
                        var draftMessage = false;
                        if(selectedStatusArr.includes("draft")){
                            draftMessage = true;
                            self.showDeleteBtn = true;
                        }
                    }
                }else{
                    self.buttonVis = false;
                    self.sendInvButton = false;
                    self.showDeleteBtn = false;
                }
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }


                self.serverParams.selectedAll = false;
            },
            backBtn: function(){
                var self = this;
                if(self.$route.query.flag == 'unsyncpayment'){
                        self.$router.push("/unsync/detail?active="+'payment');
                }else{
                    self.$router.push("/payment/list");
                }
            },
            confirmInvoices(isUnpost){
                var self = this;
                if (isUnpost){
                  self.isUnpost = true;
                }else{
                  self.isUnpost = false;
                }
                self.action="confirmInvoice"
                self.loadList();
            },
            sendInvoices() {
                var self = this;
                self.action="sendInvoice"
                self.loadList();
            },
            viewInvoice(invoiceId,invoiceOrigin,invoiceType){
                var self = this;

                self.$router.push("/invoice/main/view/"+invoiceId);

                localStorage.setItem("invoice_id",invoiceId);
                localStorage.setItem("invoice_origin",invoiceOrigin);
                localStorage.setItem("invoice_type",invoiceType);
            },
            hideMessageModal() {
                var self = this;
                self.statusMessageError = false;
                self.billedInvoicesArr = [];
                self.draftedInvoicesArr = [];
                $("#billed-invoice-message-modal").modal("hide");
            },
            financeChargeInvoice:function(){
                var self = this;

                self.$router.push('/finance/invoice');
            },
            downloadInvoice(id,type,origin,flag) {
                var self = this;
                self.loading = true ;

                var dataType = 'json';
                $.ajax({
                    url: process.env.ROOT_API + "/invoice/pdf",
                    type: "POST",
                    data: {
                        invoice_id:id,
                        invoice_type:type,
                        invoice_origin:origin,
                        for:flag
                    },
                    headers: this.ajxHeaders,
                    dataType: dataType,
                    success: function (data) {
                        self.loading = false ;
                         if (flag == 'print'){
                            var a = window.open(data, '_blank');
                            a.document.write(data);
                            a.document.close();
                            self.loading = false;
                            a.print();
                            a.close();
                        }
                        if (data.status == 'success'){

                            var link = document.createElement('a');
                            document.body.appendChild(link);
                            link.href = data.content;
                            link.download = '';
                            link.target = "_blank";
                            link.click();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'download-default-invoice');
                    }
                });

            },
            printInvoice:function(id,type){
                var self = this;
                var link = '';
                if (type == 'LC'){
                    link = "/lease-invoice/view/"+id;
                }else if(type == 'RC'){
                    link = "/rental-invoice/view/"+id;
                }else if (type == 'PE'){
                    link = "/invoice/permit/preview/"+id;
                }else if(type == 'HV'){
                    link = "/invoice/fhut/preview/"+id;
                }else if(type == 'DP'){
                    link = "/disposal-invoice/view/"+id;
                }else if(type == 'FB'){
                    link = "/invoice/fuel-ticket/preview/"+id;
                }else if(type == 'FIN'){
                    link = "/finance-charge-invoice/view/"+id;
                }else if(type == 'WO'){
                    link = "/invoice/wo/preview/"+id;
                }else{
                    link = "/invoice/manual/preview/"+id;
                }

                let routeData = self.$router.resolve(link);
                window.open(routeData.href, '_blank');
            },
            openModal: function(){
                var self = this;
                self.duplicateInvoice = [];
                self.selectedFile = "";
                $("#iftaUploadFile").val('');
                self.import_error = '';
                self.generateExcelSample();
                $('#ifta-upload-modal').modal('show');
            },
            onFileChanged(event) {
                const file = event.target.files[0];
                var self = this;
                self.selectedFile = file;
                self.import_error = '';
            },
            generateExcelSample() {
                var self = this;

                $.ajax({
                    url:
                    process.env.ROOT_API +
                    "/invoice-upload/generate",
                    type: "POST",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,

                    success: function(data) {
                        self.loading = false;
                        self.fileName = data.content.file;
                        self.file = data.content.web;

                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'ifta-upload-generate')

                    }
                });
            },
            downloadSample(){
                var self = this;
                var docPath = self.file;
                var save = document.createElement('a');
                save.href = docPath;
                save.download = docPath;
                save.target = '_blank';
                document.body.appendChild(save);
                save.click();
                document.body.removeChild(save);
            },
            importInvoices() {
                var self = this;
                self.import_error = "";
                if( self.selectedFile == "" || self.selectedFile == null){
                    self.import_error = "Please Select Excel File.";
                    return;
                }
                var fileExtension = ['xls', 'xlsx'];
                if ($.inArray(self.selectedFile.name.split('.').pop().toLowerCase(), fileExtension) == -1) {
                    self.import_error = "Only formats are allowed : "+fileExtension.join(', ');
                    return;
                }

                var formData = new FormData();
                formData.append('myFile', self.selectedFile);

                self.loading = true;
                $('#importButton').text('Fetching...');
                $('#importButton').prop('disabled',true);
                $('#cancelButton').prop('disabled',true);

                $.ajax({
                    url: process.env.ROOT_API + "/invoice-upload/import",
                    type: "POST",
                    data: formData,
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        $('#importButton').text('Import');
                        $('#importButton').prop('disabled',false);
                        $('#cancelButton').prop('disabled',false);
                        self.import_error = '';
                        if (data.code == 201) {
                            self.import_error = data.message;
                            return;
                        }
                        if (data.status == "success") {

                            if ( Object.keys(data.duplicate).length > 0){

                                self.duplicateInvoice = data.duplicate;

                            }else{
                                if(data.content != false){
                                    self.$swal('',data.content+" Records imported",'success');
                                }
                                $('#ifta-upload-modal').modal('hide');
                                self.loadList();
                            }

                        }

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        $('#importButton').text('Import');
                        $('#importButton').prop('disabled',false);
                        $('#cancelButton').prop('disabled',false);
                        self.generateStatusCodeMessage(jqXHR,true,'ifta-upload-import-error')
                    }
                });
            },
            invoiceDelete() {
                var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete this Customer Invoice?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                      self.action = "deleteInvoice";
                      self.loadList();

                    } else {
                      console.log("no");
                    }
                });
            },
            adjustInvoice:function(){
                var self = this;
                var selectedRows = [];
                var data = self.$refs['invoiceList'].selectedRows;

                if (data.length && data.length == 1){
                    if (data[0].open_amount == 0){
                        self.$swal('','Please select invoice with open amount greater than 0','info');
                        return;
                    }
                }
                for ( var i = 0; i < data.length; i++ ) {
                    selectedRows.push(self.$refs['invoiceList'].selectedRows[i].id)
                }

                self.$swal({
                    title: 'Are you sure that you want to adjust these Customer Invoices?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        $.ajax({
                            url:
                            process.env.ROOT_API + "/write-off-invoice",
                            type: "POST",
                            crossDomain: true,
                            dataType: "json",
                            data:{
                                selectedRows:selectedRows
                            },
                            headers: self.ajxHeaders,
                            success: function(data) {
                                self.loading = false;
                                self.loadList();
                            },
                            error: function(jqXHR, exception) {
                                self.loading = false;
                                self.generateStatusCodeMessage(jqXHR,true,'adjust-invoice')

                            }
                        });
                    } else {
                      console.log("no");
                    }
                });


            },
            confirmSubSysInvoice() {
                var self = this;
                self.subSystemFlag = "yes";
                self.action = "confirmInvoice";
                $("#sub-system-inv-modal").modal("hide");
                self.loadList();
            },
            hideSubSysMsgModal() {
                var self = this;
                self.subSystemFlag = "";
                self.subSystemInvArr = [];
                $("#sub-system-inv-modal").modal("hide");
            },
            getAllCustomerInvoices() {
                var self = this;
                self.allActive = 'active';
                self.draftActive = '';
                self.billedActive = '';
                self.sentActive = '';
                self.paidActive = '';
                self.deletedActive = '';
                self.status_flag = 'all';
                localStorage.setItem('customer_list_prev_tab', 'all');
                //clear filters and load list
                self.$refs.filterInvoice.onColumnFilter('cancel');
                self.loadList();
            },
            getDraftCustomerInvoices() {
                var self = this;
                self.allActive = '';
                self.draftActive = 'active';
                self.billedActive = '';
                self.sentActive = '';
                self.paidActive = '';
                self.deletedActive = '';
                self.status_flag = 'draft';
                localStorage.setItem('customer_list_prev_tab', 'draft');
                //clear filters and load list
                self.$refs.filterInvoice.onColumnFilter('cancel');
                self.loadList();
            },
            getBilledCustomerInvoices() {
                var self = this;
                self.allActive = '';
                self.draftActive = '';
                self.billedActive = 'active';
                self.sentActive = '';
                self.paidActive = '';
                self.deletedActive = '';
                self.status_flag = 'billed';
                localStorage.setItem('customer_list_prev_tab', 'billed');
                //clear filters and load list
                self.$refs.filterInvoice.onColumnFilter('cancel');
                self.loadList();
            },
            getSentCustomerInvoices() {
                var self = this;
                self.allActive = '';
                self.draftActive = '';
                self.billedActive = '';
                self.sentActive = 'active';
                self.paidActive = '';
                self.deletedActive = '';
                self.status_flag = 'sent';
                localStorage.setItem('customer_list_prev_tab', 'sent');
                //clear filters and load list
                self.$refs.filterInvoice.onColumnFilter('cancel');
                self.loadList();
            },
            getPaidCustomerInvoices() {
                var self = this;
                self.allActive = '';
                self.draftActive = '';
                self.billedActive = '';
                self.sentActive = '';
                self.paidActive = 'active';
                self.deletedActive = '';
                self.status_flag = 'paid';
                localStorage.setItem('customer_list_prev_tab', 'paid');
                //clear filters and load list
                self.$refs.filterInvoice.onColumnFilter('cancel');
                self.loadList();
            },
            getDeletedCustomerInvoices() {
                var self = this;
                self.allActive = '';
                self.draftActive = '';
                self.billedActive = '';
                self.sentActive = '';
                self.paidActive = '';
                self.deletedActive = 'active';
                self.status_flag = 'deleted';
                localStorage.setItem('customer_list_prev_tab', 'deleted');
                //clear filters and load list
                self.$refs.filterInvoice.onColumnFilter('cancel');
                self.loadList();
            },
            creditInvoice:function(){
                var self = this;

                var selectedRows = [];
                var data = self.$refs['invoiceList'].selectedRows;
                var invType = '';
                if (data.length && data.length == 1){
                    if (data.length > 1){
                        self.$swal('','Please select only one invoice','info');
                        return;
                    }
                }
                for ( var i = 0; i < data.length; i++ ) {
                    selectedRows.push(self.$refs['invoiceList'].selectedRows[i].id);
                    invType = self.$refs['invoiceList'].selectedRows[i].invoice_type_code;
                }
                var routeData = '';

                if (invType != '' && invType == 'MC'){
                    routeData = this.$router.resolve({name: 'InvoiceCreate', query: {from: "credit",inv_id:selectedRows[0]}});
                    // self.$router.push('/invoice/create?from=credit&&inv_id='+selectedRows[0]);
                }else if (invType != '' && invType == 'WO'){
                    routeData = this.$router.resolve({name: 'WorkOrderInvoiceCreate', query: {from: "credit",inv_id:selectedRows[0]}});
                    // self.$router.push('/invoice/wo/create?from=credit&&inv_id='+selectedRows[0]);
                }else if (invType != '' && invType == 'PE'){
                    routeData = this.$router.push({name: 'PermitInvoiceCreate', query: {from: "credit",inv_id:selectedRows[0]}});
                    // self.$router.push('/invoice/permit/create?from=credit&&inv_id='+selectedRows[0]);
                    return;
                }else if (invType != '' && invType == 'HV'){
                    routeData = this.$router.push({name: 'HvutInvoiceCreate', query: {from: "credit",inv_id:selectedRows[0]}});
                    // self.$router.push('/invoice/fhut/create?from=credit&&inv_id='+selectedRows[0]);
                    return;
                }
                else if (invType != '' && invType == 'RC'){
                    routeData = this.$router.push({name: 'RentalInvoiceCreate', query: {from: "credit",inv_id:selectedRows[0]}});
                    // self.$router.push('/invoice/fhut/create?from=credit&&inv_id='+selectedRows[0]);
                    return;
                }else if (invType != '' && invType == 'LC'){
                    routeData = this.$router.push({name: 'LeaseInvoiceCreate', query: {from: "credit",inv_id:selectedRows[0]}});
                    // self.$router.push('/invoice/fhut/create?from=credit&&inv_id='+selectedRows[0]);
                    return;
                }else if (invType != '' && invType == 'DP'){
                    routeData = this.$router.resolve({name: 'DisposalProceedsInvoiceCreate', query: {from: "credit",inv_id:selectedRows[0]}});
                }

                if (routeData != ''){
                    window.open(routeData.href, '_blank');
                }
            },
            //get count of status like draft,billed,sent,paid,deleted,all
            getCount(){
                var self = this;
                var fields = {
                    flag:self.status_flag,
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/customer/invoice/count",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    crossDomain: true,
                    success: function (data) {
                        if (data.status == "success") {
                            self.filteredFlag = false;
                            //check selected flag status
                            self.allCount = data.content.allCount;
                            self.draftCount = data.content.draftCount;
                            self.billedCount = data.content.billedCount;
                            self.sentCount = data.content.sentCount;
                            self.paidCount = data.content.paidCount;
                            self.deletedCount = data.content.deletedCount;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.action = "list";
                        self.generateStatusCodeMessage(jqXHR,false,'vendor-invoice-list');
                    }
                });
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/invoice/InvoiceList.vue